import { render, staticRenderFns } from "./DecidedPostDoc.vue?vue&type=template&id=7879fac3&"
import script from "./DecidedPostDoc.vue?vue&type=script&lang=js&"
export * from "./DecidedPostDoc.vue?vue&type=script&lang=js&"
import style0 from "./DecidedPostDoc.vue?vue&type=style&index=0&id=7879fac3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports